<div class="dashboard-content-sec col-md-12" style="display:inline-flex; height: 2000px">

    <iframe width="100%" height="100%" frameborder="0" src="https://myhrcounsel.documate.org/interview?i=docassemble.playground2%3AHandbook+Interview.yml#page1"></iframe>

</div>